<div id="wrapper">
    <app-login-btn [disabled]="authenticating" *ngIf="!authorized && !authenticated"></app-login-btn>

    <div class="unauthorized" *ngIf="authenticated && !authorized && user.roles !== null">
      <img class="avatar" src="{{user.avatar}}" alt="avatar">
      <p>You don't have permission to use Whistler.</p>
      <a href="#" (click)="logout()">Logout</a>
    </div>
</div>
